<strong>Ajude a melhorar o Portugol Webstudio</strong>

<p>Conte como você usa o IDE numa pesquisa rápida, de uns 4 minutos.</p>

<div class="buttons">
  <a
    class="btn btn-primary btn-sm"
    target="_blank"
    rel="external noopener"
    [href]="toastRef?.data?.url"
    (click)="onAnswer()"
  >
    Responder pesquisa
  </a>
  <button type="button" class="btn btn-ghost btn-sm" (click)="onDismiss()">Agora não</button>
</div>
